// Telefony ukládáme jako E.164 (CLAUDE.md pravidlo 11). Výchozí předvolba je česká.
const DEFAULT_COUNTRY_CODE = '420'

/** Normalizuje české a mezinárodní číslo na E.164 (+420...). Vrátí null, když to není číslo. */
export function toE164(input: string, defaultCountryCode = DEFAULT_COUNTRY_CODE): string | null {
  let digits = input.replace(/[^\d+]/g, '')
  if (digits.startsWith('00')) digits = `+${digits.slice(2)}`
  if (digits.startsWith('+')) {
    const rest = digits.slice(1)
    if (rest.length < 8 || rest.length > 15) return null
    return `+${rest}`
  }
  if (digits.length === 9) return `+${defaultCountryCode}${digits}`
  if (digits.length === 12 && digits.startsWith(defaultCountryCode)) return `+${digits}`
  return null
}

/** Formát pro zobrazení: +420 777 123 456 */
export function formatPhone(e164: string): string {
  if (!e164.startsWith('+420') || e164.length !== 13) return e164
  const n = e164.slice(4)
  return `+420 ${n.slice(0, 3)} ${n.slice(3, 6)} ${n.slice(6)}`
}
